import { Injectable } from '@angular/core';
import { BLService } from './bl.service';

@Injectable()
export class ImportService extends BLService {
  private RESOURCE_ENDPOINT = 'client/';

  public sendFileContentToImport(
    body: string,
    importParameters: {
      includeEmptyOrgNumbers: string;
      overWriteExistingOrgNumbers: string;
      clientResponsible: string;
      templatesDate: string;
    },
  ): any {
    const { includeEmptyOrgNumbers, overWriteExistingOrgNumbers, clientResponsible, templatesDate } = importParameters;

    const tempUrl = `${this.RESOURCE_ENDPOINT}import/${includeEmptyOrgNumbers}/${overWriteExistingOrgNumbers}/${clientResponsible}/${templatesDate}`;
    return this.httpPost(
      tempUrl,
      body,
      this.httpAuthHeader.getHeader({ 'Content-Type': 'application/text; charset=utf-8' }),
    );
  }

  public sendFileContentToDeferalImport(body: string, clearAll: boolean): any {
    const tempUrl = `${this.RESOURCE_ENDPOINT}defer/${clearAll}`;
    return this.httpPost<any>(
      tempUrl,
      body,
      this.httpAuthHeader.getHeader({ 'Content-Type': 'application/text; charset=utf-8' }),
    );
  }
}
